import routerOptions0 from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}